import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  createRollbackPlansBegin,
  createRollbackPlansFailed, createRollbackPlansSuccessful,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED } from '../../../configs/serverStatusCodes';
import { BACKEND_URL_V2 } from '../../../configs';

export default function* createRollbackPlans(action) {
  try {
    const pool = action.payload;
    const url = `${BACKEND_URL_V2}/audit/rollback-plans`;
    yield put(createRollbackPlansBegin());
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
    if (dataResponse.status === CREATED) {
      const data = yield getBodyJson(dataResponse);
      yield put(createRollbackPlansSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      const data = yield getBodyJson(dataResponse);
      yield put(createRollbackPlansFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createRollbackPlansFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
